import { DateTime } from "@/lib/dates"

export type DatePickerDate = {
	year: number
	month: number
	day: number
}

export type DatePickerDateWithTimezone = DatePickerDate & {
	zone?: string
}

/**
 * Transform to date picker date
 * @param dateTime
 * @returns
 */
export function transformToDatePickerDate(dateTime: Date): DatePickerDate {
	const parsedDate = DateTime.fromJSDate(dateTime)
	return {
		year: parsedDate.year,
		month: parsedDate.month,
		day: parsedDate.day,
	}
}
